export default "__VITE_ASSET__DhyYVTX1__"